<template>
  <div class="filterWrap">
    <div class="headerCloseWrap">
      <v-btn
        icon
        color="red"
        small
        @click.stop="closeWrap()"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="leftWrap leftpubWrap">
      <p style="margin-bottom: 5px">适用</p>
      <md-content class="md-scrollbar">
        <v-list-item
          v-for="(item, pIndex) in left_refer_list"
          :key="`item` + pIndex"
          link
          :value="item._id"
          @click.stop="checkLeftType(item)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox
                disabled
                v-model="item.isCheck"
                :input-value="active"
                color="purple"
                size="mini"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.name"
                  ></v-list-item-title>
                </template>
                <span>{{ item.name }} </span>
              </v-tooltip>
            </v-list-item-content>
          </template>
        </v-list-item>
      </md-content>
    </div>
    <div class="centerWrap pubWrap">
      <p style="margin-bottom: 5px">专业大类</p>

      <div class="queryIcon">
        <v-text-field
          label="查询专业大类"
          hide-details="auto"
          style="padding-top: 0px; margin-bottom: 10px"
          v-model="centerValue"
          @input="centerFilter"
        >
        </v-text-field>
        <v-icon small>fas fa-search</v-icon>
      </div>
      <v-progress-circular
        v-show="centerListLoading"
        indeterminate
        color="primary"
        class="loadingCenter"
      >
      </v-progress-circular>
      <p class="loadingCenterText" v-show="!center_refer_list.length > 0">
        暂无数据
      </p>
      <md-content class="md-scrollbar">
        <v-list-item
          v-for="(item, pIndex) in center_refer_list"
          :key="`item` + pIndex"
          link
          :value="item._id"
          @click.stop="checkCenterType(item)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox
                disabled
                v-model="item.isCheck"
                :input-value="active"
                color="purple"
                size="mini"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.name"
                  ></v-list-item-title>
                </template>
                <span>{{ item.name }} </span>
              </v-tooltip>
            </v-list-item-content>
          </template>
        </v-list-item>
      </md-content>
    </div>
    <div class="rightWrap pubWrap">
      <p style="margin-bottom: 5px">专业类</p>

      <div class="queryIcon">
        <v-text-field
          label="查询专业类"
          hide-details="auto"
          style="padding-top: 0px; margin-bottom: 10px"
          v-model="rightValue"
          @input="rightFilter"
        >
        </v-text-field>
        <v-icon small>fas fa-search</v-icon>
      </div>
      <v-progress-circular
        v-show="rightListLoading"
        indeterminate
        color="primary"
        class="loadingCenter"
      >
      </v-progress-circular>
      <p class="loadingCenterText" v-show="!right_refer_list.length > 0">
        暂无数据
      </p>
      <md-content class="md-scrollbar">
        <v-list-item
          v-for="(item, pIndex) in right_refer_list"
          :key="`item` + pIndex"
          link
          :value="item._id"
          @click.stop="checkRightType(item)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action>
              <v-checkbox
                disabled
                v-model="item.isCheck"
                :input-value="active"
                color="purple"
                size="mini"
              ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs"
                    v-on="on"
                    v-text="item.name"
                  ></v-list-item-title>
                </template>
                <span>{{ item.name }} </span>
              </v-tooltip>
            </v-list-item-content>
          </template>
        </v-list-item>
      </md-content>
    </div>
    <div class="btnWrap">
      <v-btn color="success" small @click="query"> 查询</v-btn>
    </div>
  </div>
</template>
<script>
import { categoryList } from "../../../api/user";
export default {
  data() {
    return {
      centerValue: "",
      rightValue: "",
      left_refer_list: [
        { id: 1, value: "bjrs", name: "毕节人社", isCheck: false },
        { id: 2, value: "bk", name: "本科", isCheck: false },
        { id: 3, value: "gz", name: "高职", isCheck: false },
        { id: 4, value: "zz", name: "中职", isCheck: false },
        { id: 5, value: "gj", name: "技师学院", isCheck: false },
        { id: 6, value: "jx", name: "技校", isCheck: false },
        { id: 7, value: "qy", name: "企业", isCheck: false },
      ],
      centerListLoading: false, //中间loading
      rightListLoading: false, //中间loading

      center_refer_list: [],
      copy_center_refer_list: [],
      right_refer_list: [],
      copy_right_refer_list: [],
      select: { state: "全部", abbr: "ALL" },
      items: [
        { state: "全部", abbr: "ALL" },
        { state: "已发布", abbr: "Published" },
      ],
    };
  },
  methods: {
    query() {
      let cate_type = this.left_refer_list.filter((item) => item.isCheck);
      let parentCode = this.center_refer_list.filter((item) => item.isCheck);
      let parentCode1 = this.right_refer_list.filter((item) => item.isCheck);

      let params = {
        cate_type: (cate_type[0] && cate_type[0].value) || "",
        level: "1",
        parentCode: (parentCode[0] && parentCode[0].code) || "",
      };
      if (parentCode1.length > 0) {
        params.parentCode = (parentCode1[0] && parentCode1[0].code) || "";
      }
       
      // this.closeWrap()

      console.log(params);
      this.$emit('sendForm',params)
    },
    centerFilter(data) {
      this.center_refer_list = this.fuzzyQuery(
        this.copy_center_refer_list,
        data
      );
    },
    rightFilter(data) {
      this.right_refer_list = this.fuzzyQuery(this.copy_right_refer_list, data);
    },
    fuzzyQuery(list, keyWord) {
      var arr = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i]["name"].match(keyWord) != null) {
          arr.push(list[i]);
        }
      }
      return arr;
    },

    checkLeftType(data) {
      this.left_refer_list.forEach((element) => {
        if (data.id == element.id) {
          let flag = !data.isCheck;
          if (!flag) {
            this.clearArr("all");
          }
          element.isCheck = !data.isCheck;
        } else {
          element.isCheck = false;
        }
      });
      let isQuery = this.left_refer_list.some((item) => item.isCheck);
      if (isQuery) {
       let emitData =  this.left_refer_list.some((item) => item.isCheck);
        this.$emit('clearEmit',emitData)
        this.centerReferList("center");
      }
      // this.centerReferList("center");
      this.centerValue = "";
    },
    checkCenterType(data) {
      this.center_refer_list.forEach((element) => {
        if (data._id == element._id) {
          let flag = !data.isCheck;
          if (!flag) {
            this.clearArr("right");
          }
          element.isCheck = !data.isCheck;
        } else {
          element.isCheck = false;
        }
      });

      let checkValueArr = this.center_refer_list.filter(
        (items) => items.isCheck
      );
      if (checkValueArr.length > 0) {
        this.centerReferList("right");
      }
    },
    checkRightType(data) {
      this.right_refer_list.forEach((element) => {
        if (data._id == element._id) {
          element.isCheck = !data.isCheck;
        } else {
          element.isCheck = false;
        }
      });
      let checkValueArr = this.right_refer_list.filter(
        (items) => items.isCheck
      );
      if (checkValueArr.length > 0) {
        this.centerReferList("rightright");
      }
    },

    centerReferList(type) {
      let cate_type = this.left_refer_list.filter((item) => item.isCheck);
      let parentCode = this.center_refer_list.filter((item) => item.isCheck);
      let parentCode1 = this.right_refer_list.filter((item) => item.isCheck);
      let params = {
        cate_type: (cate_type[0] && cate_type[0].value) || "",
        level: "1",
        parentCode: (parentCode[0] && parentCode[0].code) || "",
      };
      if (type == "center") {
        this.centerListLoading = true;
        params.parentCode = "";
      }
      if (type == "right") {
        params.level = "2";
        this.rightListLoading = true;
      }
      if (type == "rightright") {
        params.level = "3";
        params.parentCode = (parentCode1[0] && parentCode1[0].code) || "";
        // this.rightrightListLoading = true;
      }

      categoryList(params).then((res) => {
        if (res.data) {
          if (type == "center") {
            console.log("center");
            this.clearArr("right");
            this.centerListLoading = false;
            res.data.forEach((item) => {
              item.isCheck = false;
            });
            this.center_refer_list = res.data;
            this.copy_center_refer_list = res.data;
          }

          if (type == "right") {
            this.rightListLoading = false;
            res.data.forEach((item) => {
              item.isCheck = false;
            });
            this.right_refer_list = res.data;
            this.copy_right_refer_list = res.data;
          }
        }
      });
      // console.log(categoryList.categoryList())
    },
    clearArr(type) {
      if (type == "all") {
        this.center_refer_list = [];
        this.copy_center_refer_list = [];
        this.right_refer_list = [];
        this.copy_right_refer_list = [];
      }
      if (type == "right") {
        this.right_refer_list = [];
        this.copy_right_refer_list = [];
      }
    },
    closeWrap() {
      this.left_refer_list&&this.left_refer_list.forEach((item) => (item.isCheck = false));
      this.center_refer_list&&this.center_refer_list.forEach((item) => (item.isCheck = false));
      this.right_refer_list&&this.right_refer_list.forEach((item) => (item.isCheck = false));
      this.$emit('closeWrap',false)
    },
  },
};
</script>
<style scoped>
.filterWrap {
  width: 495px;
  height: auto;
  background: #fff;
  position: absolute;
  top: 50px;
  z-index: 9999;
  /* border: 1px solid gray; */
  padding: 5px 15px 15px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
}

.headerCloseWrap {
  text-align: right;
  overflow: hidden;
  height: 30px;
  width: 100%;
}

.md-scrollbar {
  /* background: red; */
}
.md-scrollbar.md-theme-default::-webkit-scrollbar-corner,
.md-scrollbar.md-theme-default::-webkit-scrollbar-track {
  background: #f3f3f3;
}
.md-scrollbar.md-theme-default::-webkit-scrollbar-thumb {
  background: #d5d5d5;
}
.filterWrap > .leftWrap {
  float: left;
  width: auto;
  padding: 0 10px 0 0px;
  border-right: 1px dashed #dbd5d5;
}
.filterWrap > .centerWrap {
  float: left;
  width: 180px;
  padding: 0 10px 0 10px;
  border-right: 1px dashed #dbd5d5;
  position: relative;
  min-height: 335px;
}
.filterWrap > .rightWrap {
  float: left;
  width: 180px;
  padding: 0 10px 0 10px;
  /* border-right: 1px solid #dbd5d5; */
  position: relative;
  min-height: 335px;
}

.filterWrap .leftpubWrap .v-list-item .v-list-item__action {
  margin: 0px;
  margin-right: 5px;
}

.filterWrap .leftpubWrap .v-list-item .v-list-item__content {
  padding: 0px;
}
.filterWrap .pubWrap .v-list-item .v-list-item__content .v-list-item__title {
  font-size: 14px;
}
.filterWrap .leftpubWrap .v-list-item {
  padding: 0px;
  min-height: 43px;
}

.filterWrap .pubWrap .v-list-item .v-list-item__action {
  margin: 0px;
  margin-right: 5px;
}
.filterWrap .pubWrap .v-list-item .v-list-item__content {
  padding: 0px;
}
.filterWrap .pubWrap .v-list-item {
  padding: 0px;
  min-height: 38px;
}

.filterWrap > .leftWrap .checkbox {
  margin: 0px;
  padding: 0px;
}

.filterWrap > .leftWrap .checkbox >>> .v-input__control .v-messages {
  min-height: 6px;
}

.filterWrap > .centerWrap .checkbox {
  margin: 0px;
  padding: 0px;
}

.filterWrap > .centerWrap .checkbox >>> .v-input__control .v-messages {
  min-height: 6px;
}
.filterWrap > .rightWrap .checkbox {
  margin: 0px;
  padding: 0px;
}

.filterWrap > .rightWrap .checkbox >>> .v-input__control .v-messages {
  min-height: 6px;
}

.btnWrap {
  text-align: right;
  float: right;
  height: auto;
  width: 100%;
  padding-right: 12px;
}
.loadingCenter {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  z-index: 999;
}
.loadingCenterText {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  z-index: 999;
  height: 20px;
  text-align: center;
}
.queryIcon {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.centerWrap .md-content {
  /* max-width: 400px; */
  max-height: 260px;
  overflow: auto;
}

.rightWrap .md-content {
  max-height: 260px;
  overflow: auto;
}
</style>